/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://040hmk80if.execute-api.ap-southeast-1.amazonaws.com/prestaging",
            "region": "ap-southeast-1"
        },
        {
            "name": "commandApi",
            "endpoint": "https://jt2e6dyiug.execute-api.ap-southeast-1.amazonaws.com/prestaging",
            "region": "ap-southeast-1"
        },
        {
            "name": "sdautoApi",
            "endpoint": "https://6omibuh4t9.execute-api.ap-southeast-1.amazonaws.com/prestaging",
            "region": "ap-southeast-1"
        },
        {
            "name": "stripeWebhook",
            "endpoint": "https://xhu7j6yi85.execute-api.ap-southeast-1.amazonaws.com/prestaging",
            "region": "ap-southeast-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://yo5je4ksjfgebiz7dbr4m6ulsi.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    "aws_appsync_region": "ap-southeast-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-xb7tzaxttndixdfkgxff6i6ipu",
    "aws_cognito_identity_pool_id": "ap-southeast-1:4e395fe5-a4b6-4169-aa6b-71d2e29b2831",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_LriMF0CsA",
    "aws_user_pools_web_client_id": "778dqjh4863d1sdq9o5d310vl0",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "badesk-storage113412-prestaging",
    "aws_user_files_s3_bucket_region": "ap-southeast-1"
};


export default awsmobile;
